import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { launchThinkTank } from 'components/ThinkTanks/modules/actions';
import { getMyThinkChats } from 'modules/think-seeds/actions';
import Launch from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.launch || {},
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    launchThinkTank: bindActionCreators(launchThinkTank, dispatch),
    getMyThinkChats: bindActionCreators(getMyThinkChats, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Launch));



// WEBPACK FOOTER //
// ./src/components/Launch/container/index.js